import { j as y } from "./kezios-design-system.esm172.js";
import { cloneElement as x } from "react";
import { useMantineTheme as h, Flex as u } from "@mantine/core";
const b = ({
  icon: s,
  iconProps: e,
  color: o,
  containerSize: n,
  size: l,
  style: m,
  ...c
}) => {
  const r = h(), t = l ?? n / 2 ?? 10, i = r.colors[o][1], a = r.colors[o][0], d = x(s, {
    color: r.colors[o][r.primaryShade],
    size: t,
    ...e,
    style: {
      zIndex: 1,
      ...e == null ? void 0 : e.style
    }
  });
  return /* @__PURE__ */ y.jsx(
    u,
    {
      justify: "center",
      align: "center",
      h: `${t * 2 / 16}rem`,
      w: `${t * 2 / 16}rem`,
      style: {
        borderRadius: "50%",
        border: `${t * 0.3 / 16}rem solid ${a}`,
        background: i,
        flexShrink: 0,
        ...m
      },
      ...c,
      children: d
    }
  );
};
export {
  b as RingIcon
};
